export enum PlanRowType {
    SKU = 'SKU',
    CHANNEL = 'CHANNEL',
    SEGMENT = 'SEGMENT',
}

export enum BucketType {
    TARGET = 'TARGET',
    FORECAST = 'FORECAST'
}

export interface PlanBucket {
    id: string;
    rowId: string;
    bucketDate: string;
    bucketType: BucketType;
    revenue: number;
    units: number;
    cogs: number;
    grossMargin: number;
    adsAllocated: number;
    contributionMargin: number;
    isLocked: boolean;
    isActual: boolean;
}

export interface PlanRow {
    id: string;
    planId: string;
    parentId?: string;
    rowType: PlanRowType;
    sortOrder: number;
    productId?: string;
    product?: {
        id: string;
        name: string;
        sku: string;
    };
    channelId?: string;
    channel?: {
        id: string;
        name: string;
    };
    segmentName?: string;
    aspPln?: number;
    aspOverride?: number;
    children?: PlanRow[];
    buckets: PlanBucket[];
}

export interface SalesPlan {
    id: string;
    name: string;
    periodStart: string;
    periodEnd: string;
    status: string;
}

export interface WorkspaceData {
    plan: SalesPlan;
    rows: PlanRow[];
    kpi: {
        totalRevenue: number;
        totalUnits: number;
        totalMargin: number;
        avgMargin: number;
    };
}
